import {FC} from "react";
import { Account } from "./icons/Account";
import { Activity } from "./icons/Activity";
import { Back } from "./icons/Back";
import { Cases } from "./icons/Cases";
import { Check } from "./icons/Check";
import { Chevron } from "./icons/Chevron";
import { Triangle } from "./icons/Triangle";
import { Cross } from "./icons/Cross";
import { DocumentPreview } from "./icons/DocumentPreview";
import { EmptyCases } from "./icons/EmptyCases";
import { EmptyNotifications } from "./icons/EmptyNotifications";
import { Error } from "./icons/Error";
import { Exit } from "./icons/Exit";
import { ExternalLink } from "./icons/ExternalLink";
import { Forward } from "./icons/Forward";
import { Logo } from "./icons/Logo";
import { Logo2 } from "./icons/Logo2";
import { Meatball } from "./icons/Meatball";
import { Minimize } from "./icons/Minimize";
import { PasswordHide } from "./icons/PasswordHide";
import { PasswordShow } from "./icons/PasswordShow";
import { Plus } from "./icons/Plus";
import { Plus40 } from "./icons/Plus40";
import { Search } from "./icons/Search";
import { ToggleOff } from "./icons/ToggleOff";
import { ToggleOn } from "./icons/ToggleOn";
import { Trash } from "./icons/Trash";
import { Profile40 } from "./icons/Profile40";
import { Home } from "./icons/Home";
import { Settings } from "./icons/Settings";
import { Lock } from "./icons/Lock";
import { Menu } from "./icons/Menu";
import { Sort } from "./icons/Sort";
import { More } from "./icons/More";
import { Computer } from "./icons/Computer";
import { AppStoreBadge } from "./icons/AppStoreBadge";
import { Arrow } from "./icons/Arrow";
import Logo3 from "./icons/Logo3";
import "./Icon.scss";
import { Facebook } from "./icons/Facebook";
import { Twitter } from "./icons/Twitter";
import { LinkedIn } from "./icons/LinkedIn";

export interface iSVGprops {
  color?: string;
  isActive?: boolean;
  hasUnread?: boolean;
  className?: string;
}
export interface iIcon extends iSVGprops {
  name: string;
}

export const Icon: FC<iIcon> = (props) => {
  const getIcon = () => {
    switch (props.name) {
      case 'account': return <Account {...props} />;
      case 'activity': return <Activity {...props} />;
      case 'arrow': return <Arrow />;
      case 'back': return <Back />;
      case 'cases': return <Cases {...props} />;
      case 'check': return <Check {...props} />;
      case 'chevron': return <Chevron {...props} />;
      case 'triangle': return <Triangle {...props} />;
      case 'cross': return <Cross />;
      case 'document-preview': return <DocumentPreview />;
      case 'empty-cases': return <EmptyCases />;
      case 'empty-notifications': return <EmptyNotifications />;
      case 'error': return <Error />;
      case 'exit': return <Exit />;
      case 'external-link': return <ExternalLink {...props} />;
      case 'forward': return <Forward />;
      case 'home': return <Home {...props} />;
      case 'logo': return <Logo />;
      case 'logo2': return <Logo2 />;
      case 'logo3': return <Logo3 />;
      case 'lock': return <Lock {...props} />;
      case 'meatball': return <Meatball />;
      case 'minimize': return <Minimize />;
      case 'password-hide': return <PasswordHide />;
      case 'password-show': return <PasswordShow {...props} />;
      case 'plus': return <Plus {...props} />;
      case 'plus-40': return <Plus40 />;
      case 'search': return <Search />;
      case 'settings': return <Settings {...props} />;
      case 'toggle-off': return <ToggleOff />;
      case 'toggle-on': return <ToggleOn />;
      case 'trash': return <Trash {...props} />;
      case 'profile-40': return <Profile40 />;
      case 'menu': return <Menu />;
      case 'sort': return <Sort />;
      case 'more': return <More />;
      case 'computer': return <Computer />;
      case 'app-store': return <AppStoreBadge {...props} />;
      case 'facebook': return <Facebook />;
      case 'twitter': return <Twitter />;
      case 'linkedin': return <LinkedIn />;
      default: return null;
    }
  }
  const icon = getIcon();

  return icon 
    ? <div className={`Icon-div ${props?.className || ''}`}>{icon}</div>
    : null;
};
